import UseCaseTabs from "../../components/adminDashboard/ui/usecasemaster/UseCaseTabs";

export default function UseCaseMaster() {
  return (
    <div className="ad-main">
      <div className="ad-content">
        <UseCaseTabs />
      </div>
    </div>
  );
}